import React from "react";
import PropTypes from "prop-types";

const ComplianceAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 0H75.6C75.6 8.4 84 8.4 84 8.4V42V63C84 63 67.725 84 42 84C16.275 84 0 63 0 63V42C0 42 5.47826e-05 18.9002 0 8.4C8.4 8.40022 8.4 0 8.4 0H42Z"
        fill={fill}
      />
      <mask
        id="mask0"
        //  maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="84"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84 0H42H0V21H84V0ZM84 63V52.5H0V63L42 84L84 63Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25 13.65V59.85C5.25 59.85 18.9 78.225 42 78.225C65.1 78.225 78.75 59.85 78.75 59.85V13.65C70.35 13.65 70.35 5.25 70.35 5.25H13.65C13.65 13.65 5.25 13.65 5.25 13.65ZM16.4458 8.4C16.1352 9.69792 15.6285 10.8485 14.9585 11.8536C13.8019 13.5884 12.2824 14.7056 10.8587 15.4174C9.99932 15.8471 9.15407 16.1402 8.4 16.3411V58.7406C8.77681 59.1885 9.32059 59.8093 10.0248 60.5487C11.5625 62.1632 13.85 64.3278 16.8184 66.4923C22.7654 70.8286 31.3153 75.075 42 75.075C52.6847 75.075 61.2346 70.8286 67.1816 66.4923C70.15 64.3278 72.4375 62.1632 73.9752 60.5487C74.6794 59.8093 75.2232 59.1885 75.6 58.7406V16.4458C74.3021 16.1352 73.1515 15.6285 72.1464 14.9585C70.4116 13.8019 69.2944 12.2824 68.5826 10.8587C68.1529 9.99932 67.8598 9.15407 67.6589 8.4H16.4458Z"
          fill="white"
        />
      </g>
      <path
        d="M8.4002 28.35L6.3002 31.5L4.2002 28.35L6.3002 25.2L8.4002 28.35Z"
        fill="white"
      />
      <path
        d="M8.4002 45.15L6.3002 48.3L4.2002 45.15L6.3002 42L8.4002 45.15Z"
        fill="white"
      />
      <path
        d="M79.7996 28.35L77.6996 31.5L75.5996 28.35L77.6996 25.2L79.7996 28.35Z"
        fill="white"
      />
      <path
        d="M79.7996 45.15L77.6996 48.3L75.5996 45.15L77.6996 42L79.7996 45.15Z"
        fill="white"
      />
      <path
        d="M6.35254 31.5L10.29 36.5806L6.35254 42L2.41504 36.5806L6.35254 31.5Z"
        fill="white"
      />
      <path
        d="M77.752 31.5L81.6895 36.5806L77.752 42L73.8145 36.5806L77.752 31.5Z"
        fill="white"
      />
      <path
        opacity="0.75"
        d="M44.1004 56.6999V59.8499H24.1504V56.6999H44.1004Z"
        fill="white"
      />
      <path
        d="M27.2758 52.4999H41.3897L43.0502 54.1799V56.6999H25.2002V54.1799L27.2758 52.4999Z"
        fill="white"
      />
      <rect
        x="33.1504"
        y="32.2786"
        width="16.8"
        height="10.5"
        transform="rotate(-30 33.1504 32.2786)"
        fill="white"
      />
      <path
        opacity="0.75"
        d="M28.2693 31.4597L30.3359 30.2666C31.5759 29.5507 32.2221 30.6698 32.2221 30.6698L39.3298 42.9807C39.3298 42.9807 39.9759 44.0999 38.7359 44.8158L36.6693 46.009C35.4293 46.7249 34.7831 45.6057 34.7831 45.6057L27.6755 33.2948C27.6755 33.2948 27.0293 32.1757 28.2693 31.4597Z"
        fill="white"
      />
      <path
        opacity="0.75"
        d="M47.365 20.4347L49.4316 19.2415C50.6716 18.5256 51.3178 19.6448 51.3178 19.6448L58.4255 31.9557C58.4255 31.9557 59.0716 33.0749 57.8316 33.7908L55.765 34.984C54.525 35.6999 53.8788 34.5807 53.8788 34.5807L46.7712 22.2698C46.7712 22.2698 46.125 21.1506 47.365 20.4347Z"
        fill="white"
      />
      <rect
        opacity="0.75"
        x="41.1289"
        y="39.7969"
        width="10.5"
        height="2.1"
        transform="rotate(-30 41.1289 39.7969)"
        fill="white"
      />
      <path
        d="M44.9072 40.0405L48.5445 37.9405L56.4994 51.7188C56.4994 51.7188 57.4695 53.3991 55.6509 54.4491C53.8322 55.4991 52.8621 53.8188 52.8621 53.8188L44.9072 40.0405Z"
        fill="white"
      />{" "}
    </svg>
  );
};

ComplianceAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

ComplianceAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default ComplianceAwardIcon;
